import React from 'react'
import { wrapTranslation } from '../../../util/wrapTranslation'

export class FxaPrompt extends React.Component {
  componentDidMount() {
    snowplow('enableFormTracking')
  }

  render() {
    const { dict, route } = this.props
    const faqLink = 'https://support.mozilla.org/kb/pocket-firefox-account-migration' //prettier-ignore
    const yesText = wrapTranslation(dict.fxaYestext, [{ a: { href: faqLink } }])
    const noText = wrapTranslation(dict.fxaNotext, [
      { strong: {} },
      { a: { href: faqLink } }
    ])

    return (
      <div className="fxa-container coreform-container loginform-container">
        <h2>{dict.fxaCalltoaction}</h2>
        <p>{dict.fxaWannaproceed}</p>
        <form action="/fxa_upgrade_process" id="fxa-upgrade-form" method="post">
          <div>
            <label htmlFor="fxaYes">
              <input
                type="radio"
                name="fxa-migrate"
                value="yes"
                id="fxaYes"
                defaultChecked
              />
              <div className="label-helper-text">
                <div className="label-header">{dict.fxaYeslabel}</div>
                <div className="label-body">{yesText}</div>
              </div>
            </label>
          </div>
          <div className="fxa-divider" />
          <div>
            <label htmlFor="fxaNo">
              <input
                type="radio"
                name="fxa-migrate"
                value="no"
                id="fxaNo"
              />
              <div className="label-helper-text">
                <div className="label-header">{dict.fxaNolabel}</div>
                <div className="label-body">{noText}</div>
              </div>
            </label>
          </div>
          <div className="fxa-footer">
            <input
              name="route"
              value={route}
              type="hidden"
            />
            <input
              id="fxaSubmit"
              className="login-btn-email"
              type="submit"
              value={dict.fxaConfirm}
            />
          </div>
        </form>
      </div>
    )
  }
}
